import React, { useEffect, useState } from 'react'
import DesktopHeaderWrap from 'components/DeskTopHeaderWrap'
import ImageZoom from './ImageZoom'
import { getDetail, getByClient as getProductsDetail } from 'api/products'
import { Card, Container, IconButton, useMediaQuery } from '@material-ui/core'
import { useStyles } from './style'
import { priceFormatLocal } from 'utils/helper'
import RelatedProduct from './RelatedProduct'
import i18n from '../language/localization'
import { withNamespaces } from 'react-i18next'
import SkeletonCircleText from 'components/common/SkeletonCircleText'
import AddToCartForm from './AddToCartForm'
import RestrictMobile from 'components/RestrictMobile'
import { useTheme } from '@material-ui/core/styles'
import { Copy } from 'iconsax-react'
import { useDispatch } from 'react-redux'
import { setSnackbar } from 'stores/features/snackbar/snackbar'

const SingleProductDetail = ({ t }) => {
  const dispatch = useDispatch()
  const theme = useTheme()
  const [categoriesData, setCategoriesData] = useState([])
  const [loading, setLoading] = useState(true)
  const [defaultImage, setDefaultImage] = useState('')
  const [dataImage, setDataImage] = useState([])
  const [dataDetail, setDataDetail] = useState({})
  const [relatedProductsData, setrelatedProductsData] = useState([])
  const [dataCategory, setDataCategory] = useState({})
  const [dataUnit, setDataUnit] = useState({})

  useEffect(() => {
    i18n.changeLanguage(JSON.parse(localStorage.getItem('Language')))
  }, [])

  const urlStr = window.location.href
  const data11 = urlStr.split('/')
  const ids = data11[3].toString()
  const productID = ids.slice(15)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const datauser = JSON.parse(localStorage.getItem('userdata'))

  const landingPageValue = JSON.parse(localStorage.getItem('landing_page'))

  const classes = useStyles()

  const singleData = () => {
    setLoading(true)
    const getProductDetail = async () => {
      try {
        const response = await getDetail(productID)
        if (response.success) {
          setLoading(false)
          setDataCategory(response.data.category)
          setDataUnit(response.data.unit)

          let defaultImage = '/assets/images/dummy.png'
          let sortedMedia = null
          if (response.data.product.media && response.data.product.media.length > 0) {
            let mp4Path = null
            for (const item of response.data.product.media) {
              if (item.endsWith('.mp4')) {
                mp4Path = item
                break
              }
            }

            if (mp4Path === null) {
              defaultImage =
                process.env.REACT_APP_FILE_BASE_URL + '/' + response.data.product.media[0]
            } else {
              defaultImage = process.env.REACT_APP_FILE_BASE_URL + '/' + mp4Path
            }

            sortedMedia = response.data.product.media.slice().sort((a, b) => {
              if (a.endsWith('.mp4') && !b.endsWith('.mp4')) {
                return -1
              } else if (!a.endsWith('.mp4') && b.endsWith('.mp4')) {
                return 1
              } else {
                return 0
              }
            })
          }
          setDefaultImage(defaultImage)
          setDataImage(sortedMedia)
          setDataDetail(response.data.product)

          if (landingPageValue.setting_cms.is_show_related_products === true) {
            let responseRelatedProductResult = await getProductsDetail(
              `{"page": 1, "limit": 25, "category_id":${response.data.product.category_id} }`
            )

            if (responseRelatedProductResult.data && responseRelatedProductResult.data.length > 0) {
              responseRelatedProductResult = responseRelatedProductResult.data.filter(
                data => data.product.id !== response.data.product.id
              )
            }
            setrelatedProductsData(responseRelatedProductResult)
          }
        }
      } catch (error) {
        console.log('Error fetching getDetailData:', error)
      }
    }

    getProductDetail()

    if (localStorage.getItem('landing_page')) {
      setCategoriesData(JSON.parse(localStorage.getItem('landing_page'))['product_categories'])
    }
  }

  useEffect(() => {
    singleData()
  }, [])

  if (isMobile && datauser.role === 'requestor') {
    return <RestrictMobile />
  }

  return (
    <div>
      <DesktopHeaderWrap showCategory isFixed={false} categoriesData={categoriesData} />
      <Container maxWidth='lg'>
        {loading ? (
          <Card className={classes.card}>
            <div className={classes.contentImage}>
              <SkeletonCircleText style={{ width: 180, height: 180 }} />
            </div>
            <div className={classes.contentMain}>
              <SkeletonCircleText style={{ width: '80%', height: 30, marginBottom: 10 }} />
              <SkeletonCircleText style={{ width: '80%', height: 30, marginBottom: 10 }} />
              <SkeletonCircleText style={{ width: '80%', height: 30, marginBottom: 10 }} />
              <SkeletonCircleText style={{ width: '80%', height: 30, marginBottom: 10 }} />
              <SkeletonCircleText style={{ width: '80%', height: 30 }} />
            </div>
          </Card>
        ) : (
          <Card className={classes.card}>
            <div className={classes.contentImage}>
              <ImageZoom
                images={dataImage}
                defaultImage={defaultImage}
                productName={dataDetail.name}
              />
            </div>
            <div className={classes.contentMain}>
              <div className={classes.mainItem}>
                <p className={classes.mainItemTitle}>Material ID</p>
                <p className={classes.mainItemSpacer}>:</p>
                <p className={classes.mainItemValue} style={{ marginBottom: 0 }}>
                  {dataDetail.sku}{' '}
                  <IconButton
                    size='small'
                    style={{ width: '24px', height: '24px', marginLeft: 4 }}
                    onClick={() => {
                      const textArea = document.createElement('textarea')
                      textArea.value = dataDetail.sku
                      document.body.appendChild(textArea)
                      textArea.focus()
                      textArea.select()
                      try {
                        document.execCommand('copy')
                      } catch (err) {
                        console.error('Unable to copy to clipboard', err)
                      }
                      document.body.removeChild(textArea)
                      dispatch(
                        setSnackbar({
                          show: true,
                          message: 'Material ID copied'
                        })
                      )
                    }}
                  >
                    <Copy size={16} />
                  </IconButton>
                </p>
              </div>
              <div className={classes.mainItem}>
                <p className={classes.mainItemTitle}>Material Name</p>
                <p className={classes.mainItemSpacer}>:</p>
                <p className={classes.mainItemValue}>{dataDetail.name}</p>
              </div>
              <div className={classes.mainItem}>
                <p className={classes.mainItemTitle}>Material Group</p>
                <p className={classes.mainItemSpacer}>:</p>
                <p className={classes.mainItemValue}>{dataCategory.name}</p>
              </div>
              <div className={classes.mainItem}>
                <p className={classes.mainItemTitle}>Unit Price</p>
                <p className={classes.mainItemSpacer}>:</p>
                <p className={classes.mainItemValue}>{priceFormatLocal(dataDetail.price)}</p>
              </div>
              <div className={classes.mainItem}>
                <p className={classes.mainItemTitle}>Stock</p>
                <p className={classes.mainItemSpacer}>:</p>
                <p className={classes.mainItemValue}>
                  {dataDetail.stock} {dataUnit?.name}
                </p>
              </div>
              <AddToCartForm data={dataDetail} unit={dataUnit} ids={ids} t={t} />
            </div>
          </Card>
        )}
        <div style={{ marginTop: 40 }}>
          {Boolean(relatedProductsData.length) && (
            <RelatedProduct dataSimilar={relatedProductsData} t={t} />
          )}
        </div>
      </Container>
    </div>
  )
}

export default withNamespaces()(SingleProductDetail)
